var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "hot-article clear bord",
      attrs: { id: "hot-news-container", "data-spm": "tw" },
    },
    [
      _c(
        "div",
        { attrs: { id: "hot-news" } },
        [
          _vm._m(0),
          _vm._v(" "),
          _vm._l(_vm.contentArr, function (item) {
            return _c(
              "div",
              {
                key: item,
                staticClass: "pic-txt clear",
                attrs: {
                  "data-loc": "3",
                  "data-ev": item.id,
                  "data-media-id": item.authorId,
                  "data-spm-type": "resource",
                  "data-spm-content": _vm.dataSpmCnt(item),
                  "data-newsid": item.position,
                },
              },
              [
                _c("div", { staticClass: "pic img-do" }, [
                  _c("a", { attrs: { href: item.url, target: "_blank" } }, [
                    _c("img", {
                      attrs: {
                        alt: "",
                        "data-src": item.picUrl,
                        src: _vm.preloadUrl,
                      },
                    }),
                    _vm._v(" "),
                    item.index
                      ? _c("span", { staticClass: "sn" }, [
                          _vm._v(_vm._s(item.index)),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _c("h4", [
                  _c(
                    "a",
                    {
                      attrs: {
                        target: "_blank",
                        href: item.url,
                        "data-spm-type": "content",
                      },
                    },
                    [_vm._v(_vm._s(item.title))]
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  item.pv
                    ? _c("a", { attrs: { href: item.url, target: "_blank" } }, [
                        _c(
                          "em",
                          {
                            attrs: {
                              "data-role": "read-count",
                              "data-id": item.id,
                            },
                          },
                          [_vm._v(_vm._s(item.pv))]
                        ),
                        _vm._v("\n                    阅读\n                "),
                      ])
                    : _vm._e(),
                ]),
              ]
            )
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleR" }, [
      _c("span", { staticClass: "tt" }, [_vm._v("24小时热文")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }